import Icon3dIndicator from '../../src/legacy/Icon3dIndicator';
export default Icon3dIndicator;
